import React from "react";
import './Footer.css';

function Footer() {
    return (
        <footer>
            <p>For Source Code, bug report, or suggestions: <a href='https://github.com/yingmo55/which-language-first' 
            rel="noopener noreferrer" target='_blank'>GitHub</a></p>
        </footer>
    )
}

export default Footer;